import moment from 'moment'
/* eslint-disable */
const tableHeaders = [
  {
    text: 'Actions',
    value: 'action',
    align: 'start'
  },
  {
    text: 'Quote Acceptance Date',
    value: 'formattedAcceptanceDate',
    align: 'start'
  },
  {
    text: 'Sales',
    value: 'salePersonName',
    align: 'start'
  },
  {
    text: 'Billing Name',
    value: 'billingContactName',
    align: 'start'
  },
  {
    text: 'Quote No.',
    value: 'quoteNo',
    align: 'start'
  },
  {
    text: 'Quote Amt (excl. GST)',
    value: 'quoteAmt',
    align: 'start'
  },
  {
    text: 'Invoice Sent',
    value: 'invoiceSent',
    align: 'start'
  },
  {
    text: 'Invoice Created on Xero',
    value: 'invoiceCreated',
    align: 'start'
  },
  {
    text: 'Yet to Invoice',
    value: 'invoicePending',
    align: 'start'
  },
  {
    text: 'Vertical',
    value: 'verticals',
    align: 'start'
  },
  {
    text: 'Type of Clients',
    value: 'clientType',
    align: 'start'
  },
  {
    text: 'Line of Services',
    value: 'lineOfServices',
    align: 'start'
  },
  {
    text: 'Campaign Name',
    value: 'campaigns',
    align: 'start'
  },
  {
    text: 'Indicate Cost (For Markup)',
    value: 'indicateCost',
    align: 'start'
  },
  {
    text: 'AM',
    value: 'AM',
    align: 'start'
  },
  {
    text: 'CC',
    value: 'CC',
    align: 'start'
  },
  {
    text: 'Start',
    value: 'startMonth',
    align: 'start'
  },
  {
    text: 'End',
    value: 'endMonth',
    align: 'start'
  },
  {
    text: 'Mth',
    value: 'totalMonth',
    align: 'start'
  },
  {
    text: `Prior ${moment().format('YYYY')}`,
    value: 'priorYear',
    align: 'start'
  },
  {
    text: `Jan-${moment().format('YY')}`,
    value: 'Jan',
    align: 'start'
  },
  {
    text: `Feb-${moment().format('YY')}`,
    value: 'Feb',
    align: 'start'
  },
  {
    text: `Mar-${moment().format('YY')}`,
    value: 'Mar',
    align: 'start'
  },
  {
    text: `Apr-${moment().format('YY')}`,
    value: 'Apr',
    align: 'start'
  },
  {
    text: `May-${moment().format('YY')}`,
    value: 'May',
    align: 'start'
  },
  {
    text: `Jun-${moment().format('YY')}`,
    value: 'Jun',
    align: 'start'
  },
  {
    text: `Jul-${moment().format('YY')}`,
    value: 'Jul',
    align: 'start'
  },
  {
    text: `Aug-${moment().format('YY')}`,
    value: 'Aug',
    align: 'start'
  },
  {
    text: `Sep-${moment().format('YY')}`,
    value: 'Sep',
    align: 'start'
  },
  {
    text: `Oct-${moment().format('YY')}`,
    value: 'Oct',
    align: 'start'
  },
  {
    text: `Nov-${moment().format('YY')}`,
    value: 'Nov',
    align: 'start'
  },
  {
    text: `Dec-${moment().format('YY')}`,
    value: 'Dec',
    align: 'start'
  },
  {
    text: `For Year ${moment().add(1, 'years').format('YYYY')}`,
    value: 'nextYear',
    align: 'start'
  },
  {
    text: `Revenue yet to recognise`,
    value: 'revenueYetRecognise',
    align: 'start'
  },
  {
    text: `Unallocated Revenues`,
    value: 'unrecognisedRevenues',
    align: 'start'
  },
  {
    text: `Accrued Revenue`,
    value: 'accruedRevenue',
    align: 'start'
  },
  {
    text: `Deferred Revenue`,
    value: 'deferredRevenue',
    align: 'start'
  }
]
const financeCols = [
  'ccDate',
  'sales',
  'billingName',
  'quoteNo',
  'quoteAmt'
]
const quoteStatuses = {
  PENDING: 0,
  ACCEPT: 1,
  REJECT: 2
}
const defaultTotalValues = {
  quoteAmt: 0,
  invoiceSent: 0,
  invoiceCreated: 0,
  invoicePending: 0,
  priorYear: 0,
  Jan: 0,
  Feb: 0,
  Mar: 0,
  Apr: 0,
  May: 0,
  Jun: 0,
  Jul: 0,
  Aug: 0,
  Sep: 0,
  Oct: 0,
  Nov: 0,
  Dec: 0,
  nextYear: 0,
  revenueYetRecognise: 0,
  unrecognisedRevenues: 0,
  accruedRevenue: 0,
  deferredRevenue: 0
}
const dynamicMonthLists = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
]
export default {
  tableHeaders,
  financeCols,
  quoteStatuses,
  defaultTotalValues,
  dynamicMonthLists
}


// WEBPACK FOOTER //
// ./src/components/views/Campaign/MasterLists/config.js